
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import BookingCalendar from "@/components/BookingCalendar";
import BookingForm from "@/components/booking/BookingForm";
import type { BookingFormData } from "@/components/booking/BookingForm";

interface BookingCalendarSectionProps {
  checkIn?: Date;
  checkOut?: Date;
  bookingDetails: any | null;
  isSubmitting: boolean;
  onDatesSelected: (dates: { checkIn: Date | undefined; checkOut: Date | undefined }) => void;
  onSubmit: (formData: BookingFormData) => void;
}

const BookingCalendarSection: React.FC<BookingCalendarSectionProps> = ({
  checkIn,
  checkOut,
  bookingDetails,
  isSubmitting,
  onDatesSelected,
  onSubmit,
}) => {
  return (
    <div className="lg:col-span-2 space-y-8">
      <Card className="shadow-md">
        <CardContent className="p-6">
          <h2 className="text-2xl font-playfair text-villa-blue mb-6">
            Sélectionnez vos dates
          </h2>
          <BookingCalendar onDatesSelected={onDatesSelected} />
        </CardContent>
      </Card>
      
      {bookingDetails && (
        <Card className="shadow-md">
          <CardContent className="p-6">
            <h2 className="text-2xl font-playfair text-villa-blue mb-6">
              Complétez votre réservation
            </h2>
            <BookingForm
              onSubmit={onSubmit}
              isSubmitting={isSubmitting}
            />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default BookingCalendarSection;
